import axios from "axios";
import { logout } from "../authService";

import { store } from "../../src";
import { selectUser } from "../../src/reducers/user";

export const axiosInstance = axios.create({});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      logout();
    }
    return Promise.reject(error);
  }
);

export const axiosInstanceWithIdentityProviderHeader = axios.create({});

axiosInstanceWithIdentityProviderHeader.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      logout();
    }
    return Promise.reject(error);
  }
);

axiosInstanceWithIdentityProviderHeader.interceptors.request.use(
  (config) => {
    const state = store.getState();
    const user = selectUser(state);
    if (user?.accessToken) {
      config.headers = Object.assign({}, config.headers, {
        Authorization: `Bearer ${user.accessToken}`,
      });
    }
    if (user?.provider) {
      config.headers = Object.assign({}, config.headers, {
        "X-Identity-Provider": user.provider,
      });
    }
    return config;
  },
  (error) => Promise.reject(error)
);
